module.exports = __webpack_public_path__ + "static/media/obrazac-licence.28573ad7.pdf";